
import React ,{useEffect, useState} from 'react'
import Cookies from 'universal-cookie';
import Button from '../Button/Button';
import CopyToClipboardButton from '../CopyToClipboardButton/CopyToClipboardButton';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import Modal from '../Modal/Modal';
import deleteIcon from '../../images/deleteIcon.svg';
import PestControlIcon from '@mui/icons-material/PestControl';
import './Debugger.scss';
import InfoIcon from '@mui/icons-material/Info';
import UpdateIcon from '@mui/icons-material/Update';
import BackendSecrets from '../BackendSecrets/BackendSecrets';

export default function Debugger() {

  const cookies = new Cookies();
  const [login, set_login]=useState(cookies.get("login").toLowerCase());
  const [open,set_open]=useState(false);
  const[has_debugger,set_has_debugger]=useState(false);
  const [open_delete,set_open_delete]=useState(false);
  const[create_debugger,set_create_debugger] = useState(false);
  const [delete_debugger,set_delete_debugger] = useState(false);
  const [re_create_debugger,set_re_create_debugger] = useState(false);
  const [consts,set_consts]=useState([]);

  useEffect(()=>{
    hasDebugger();
  }
  ,[]);

  async function hasDebugger(){
    var options = {
      'method': 'POST',
      'headers': {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      "userName": login,
      "code" : cookies.get("code")
    })
    };
    return fetch(process.env.REACT_APP_INFRA_SERVICE_URL+"/debugger/hasDebugger/" , options)
    .then(response=>response.json())
    .then(async data=>{ 
      try{
        set_has_debugger(data.hasDebugger);
        set_consts(data.consts);
        return data.hasDebugger;  // return the value so it can be checked in the while loop
      }
      catch(error) {
        console.log('has debugger error', error);
        return false; // return false if there's an error
      }
    });
  }
  async function createDebugger(){
    set_create_debugger(true);
    await createDebuggerHandler();

  }

  async function createDebuggerHandler(){
    var options = {
      'method': 'POST',
      'headers': {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      "userName": login,
      "code" : cookies.get("code")
    })
    };
    fetch(process.env.REACT_APP_INFRA_SERVICE_URL+"/debugger/create/" , options).then(response=>response.json())
    .then(async data=>{ 
      try{
        set_open(true);
        set_create_debugger(false);
      }
      catch(error) {
        console.log('create debugger error', error);
      }
    });
  }

  async function deleteDebugger(){
    set_delete_debugger(true);
    await deleteDebuggerHandler();
    set_delete_debugger(false);
    set_open_delete(true);
  }

  async function deleteDebuggerHandler(){
    var options = {
      'method': 'POST',
      'headers': {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      "userName": login,
      "code" : cookies.get("code")
    })
    };
    await fetch(process.env.REACT_APP_INFRA_SERVICE_URL+"/debugger/kill/" , options)
    .then(response=>response.json())
    .then(async data=>{ 
      try{
        while(await hasDebugger()){  // use await here to handle Promise value
          await new Promise(r => setTimeout(r, 10000)); //sleep 5 sec
        }
        return data;
      }
      catch(error) {
        console.log('create debugger error', error);
      }
    });
  }

  async function reCreateDebugger(){
    set_re_create_debugger(true);
    await deleteDebuggerHandler();
    await createDebuggerHandler();
    set_re_create_debugger(false);
  }
  return (
    <div className="split right">
      <div className="box" style={{"background": "white" , "display" : "block" , "height": "max-content" , "padding-left": "2em" , "padding-bottom": "2em" , "font-size": "medium"}}>
        <h2>How to create and use debugger ? 
          <InfoIcon sx={{ color: "primary.main" , cursor: "pointer" }} onClick={() => window.open("https://workiz.atlassian.net/wiki/spaces/WOR/pages/2312568834/pod+debugger")}/>
        </h2>
        
        <List sx={{ listStyle: "decimal", pl: 4 }} >
        {has_debugger ? 
          (<ListItem divider={true} sx={{display: "block"}}> 1. You already have a debugger pod. 
          <ListItem sx={{paddingTop: "0" , paddingBottom: "0"}}> To delete it - 
          <Button text="delete pod" onClick={()=>{ deleteDebugger()} } className="delete" loader={delete_debugger} startIcon={<img src={deleteIcon}/>} style={{"display": "inline" , "margin-left": "10px"}} />
          </ListItem>
          <ListItem sx={{paddingTop: "0" , paddingBottom: "0"}}> To update it -
          <Button text="update pod" onClick={()=>reCreateDebugger()} className="update" startIcon={<UpdateIcon/>} loader={re_create_debugger} style={{"display": "inline" , "margin-left": "10px"}} />
          </ListItem>
          </ListItem>) : 
          (<ListItem divider={true}>
            1. create debugger pod - 
            
            <Button text="create" onClick={()=>createDebugger()} className="update" startIcon={<PestControlIcon/>} loader={create_debugger} style={{"display": "inline" , "margin-left": "10px"}} />
            </ListItem>
          )
          }
          <ListItem divider={true}>
          2. Stop local env - 
          <CopyToClipboardButton text={"workiz-kill"}/> 
          </ListItem> 
        <ListItem divider={true}>
          3. Update your hosts file. Run -
          <CopyToClipboardButton text={"debugger-host-add"}/> 
          </ListItem> 
        
        <ListItem divider={true}>
        4. Run -
        <CopyToClipboardButton text={`tsh kube login wstgcluster && sudo kubectl port-forward pod/debugger-${login}-0 -n prod 443:443`}/>
        
        </ListItem>
        <ListItem divider={true}>
        5. Open in browser -
        <a href= {`https://app.workiz.com`} target="_blank" >https://app.workiz.com</a>
        </ListItem>
        <ListItem divider={true}>
        6. To enter the pod run -
        <CopyToClipboardButton text={`kubectl exec -it debugger-${login}-0 bash -n prod`}/>
        </ListItem>
        <ListItem divider={true}>
          7. Backend is in -
          <CopyToClipboardButton text={`cd /var/www/app.workiz.com`}/>
        </ListItem>
        <ListItem divider={true}>
          8. To stop debugger -
          <CopyToClipboardButton text={`debugger-host-remove`}/>
        </ListItem>
        </List>
        {has_debugger && 
          <div>
            <h2>Debugger consts:</h2>
            <BackendSecrets env={"debugger"} secrets={consts}/>
            
          </div>
        }
      </div>
      <Modal open={open} onClose={()=>set_open(false)} setOpen={set_open} title={"Debugger created successfully"} text={"Please wait a few minutes for the debugger to be ready"}
        buttons={[
          {"text":"Ok" ,  "class": "modalOK" , "onClick": ()=>{set_open(false); set_has_debugger(true)}}
        ]}/>
      <Modal open={open_delete} onClose={()=>set_open_delete(false)} setOpen={set_open_delete} title={"Debugger deleted successfully"}
        buttons={[
          {"text":"Ok" ,  "class": "modalOK" , "onClick": ()=>{set_open_delete(false); set_has_debugger(false)}}
        ]}/>
    </div>
  )
}